import appEnv from 'bundles/authentication/appEnv';
import appStarterFactory from 'bundles/page/lib/appStarterFactory';

export default appStarterFactory(appEnv);
